import { Group } from 'lib/_types'
import { endpoints } from 'store/api/yay/group'

export const useGroupIcon = ({
  fallbackToGroupCover,
}: {
  fallbackToGroupCover?: boolean
} = {}) => {
  const groupCategoriesRes = endpoints?.getGroupCategories?.useQueryState?.({})

  return {
    getGroupIcon: ({ group }: { group: Group }) => {
      const groupCategory = groupCategoriesRes?.data?.find?.(
        (x) => x?.id == group?.group_category_id
      )

      let icon = group?.group_icon

      if (fallbackToGroupCover) {
        icon ??= group?.cover_image
      }

      return {
        icon,
        placeholder: groupCategory?.icon,
      }
    },
  }
}
